import {FreeTrialPeriod} from '@wix/auto_sdk_ecom_current-cart';
import {SubscriptionFrequency, toSubscriptionFrequency} from './SubscriptionSettings.model';
import {mapNullToUndefined} from '../utils/mapperHelper.utils';

export class FreeTrialPeriodModel {
  public frequency: SubscriptionFrequency;
  public interval?: number;

  constructor(params: FreeTrialPeriodModel) {
    this.frequency = params.frequency;
    this.interval = params.interval;
  }

  public static fromSDK(freeTrialPeriod?: FreeTrialPeriod | null) {
    return new FreeTrialPeriodModel({
      frequency: toSubscriptionFrequency(freeTrialPeriod?.frequency),
      interval: mapNullToUndefined(freeTrialPeriod?.interval),
    });
  }
}
